export const __DEV__ = process.env.NODE_ENV === 'development';

export function getRandomNumber() {
  return Math.floor(Math.random() * 10);
}
